import { RouteRecordRaw } from 'vue-router';
import { requireAuth, setDayjsTimezone } from '@/common/router/navigationGuard';
import { extractAccessibleRoutes } from '@/common/auth/auth.utils';
import { ROLE_PERMISSION_KEY } from '@/common/define/rolePermission.define';
import BaseViewport from '@/common/components/templates/baseViewport/BaseViewport.vue';
import { VIEWPORT_TYPE } from '@/common/components/templates/baseViewport/baseViewport.define';

const PREFIX = 'tool_';

const toolMenu: RouteRecordRaw[] = [
  {
    path: '/tool/',
    name: 'Tool',
    component: BaseViewport,
    beforeEnter: [requireAuth, setDayjsTimezone],
    meta: {
      rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TOOL,
      viewport: VIEWPORT_TYPE.PA_HEADER_TIME,
    },
    children: [
      {
        path: 'script-manager',
        name: `${PREFIX}Script Manager`,
        component: () => import('@/infrastructure/views/scriptManagerView/ScriptManagerView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TOOL_SCRIPT_MANAGER,
        },
      },
      {
        path: 'script-manager-history',
        name: `${PREFIX}Script Manager History`,
        component: () =>
          import('@/infrastructure/views/scriptManagerHistoryView/ScriptManagerHistoryView.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TOOL_SCRIPT_MANAGER_HISTORY,
        },
      },
      {
        path: 'query-manager',
        name: `${PREFIX}Query Manager`,
        component: () => import('@/tool/views/queryManager/QueryManager.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TOOL_QUERY_MANAGER,
        },
      },
      {
        path: 'query-manager-history',
        name: `${PREFIX}Query Manager History`,
        component: () => import('@/tool/views/queryManagerHistory/QueryManagerHistory.vue'),
        meta: {
          rolePermission: ROLE_PERMISSION_KEY.MONITORING.MONITORING_TOOL_QUERY_MANAGER_HISTORY,
        },
      },
    ],
  },
];
const getToolMenu = () => {
  const filteredToolMenu = extractAccessibleRoutes(toolMenu);

  return [...filteredToolMenu];
};

export { toolMenu, getToolMenu };
